import { render, staticRenderFns } from "./InvoiceRecurrenceDialog.vue?vue&type=template&id=63606fe0&scoped=true"
import script from "./InvoiceRecurrenceDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceRecurrenceDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecurrenceDialog.vue?vue&type=style&index=0&id=63606fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63606fe0",
  null
  
)

export default component.exports